import ConfirmationSignalScheduleRoot from '../../components/pages/ConfirmationSignalSchedule';
import { FullHeightOnly } from '../../components/shared/Grid';
import TemplateCenter from '../../layout/TemplateCenter';

const ConfirmationSignalSchedule = () => {
  return (
    <TemplateCenter>
      <FullHeightOnly>
        <ConfirmationSignalScheduleRoot />
      </FullHeightOnly>
    </TemplateCenter>
  );
};

export default ConfirmationSignalSchedule;
